import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { GetEnvelopeOwnersResponse } from './get-envelope-owners.types'

const getEnvelopeOwners = async (): Promise<GetEnvelopeOwnersResponse> => {
  const response = await apiClient.get<GetEnvelopeOwnersResponse>(
    '/v1/ecm/envelopes/owners',
  )
  return response.data
}

export const useGetEnvelopeOwners = (enabled = true) => {
  return useQuery({
    queryKey: ['envelope-owners'],
    queryFn: () => getEnvelopeOwners(),
    enabled,
  })
}
